import { LoadingButton } from "@mui/lab";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { Auth } from "../../api/Channel/Auth";
import { CommonAPI } from "../../api/Channel/Common";
import useCountDown from "common/hooks/useCountDown";
import { useFetch } from "common/hooks/useFetch";
import { successMsg } from "helper/message";
import { queryKeys } from "helper/react-query";
import { LOCAL_STORAGE, getDataSession, setDataSession } from "helper/session";
import { removeCmsToken } from "helper/user";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import OtpInput from "react18-input-otp";
import { setIsConfirmUser } from "redux/userReducer";
import CloseIcon from "@mui/icons-material/Close";

const OTP = ({
  isShowModal,
  isChangePassword,
  handleCloseModal = () => {},
  handleCloseSuccess = () => {},
  getOTP,
}) => {
  const { t } = useTranslation("uaa");

  const [otpValue, setOtpValue] = useState("");
  const { counter, start, reset } = useCountDown(60);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { watch } = useFormContext();

  // const { data, isLoading, refetch } = useFetch(
  //   CommonAPI.getOTP,
  //   null,
  //   queryKeys.GET_OTP,
  //   {
  //     enabled: !isChangePassword,
  //     payloadNotAsKey: true,
  //   }
  // );

  const { mutateAsync: verifyOTP, isLoading: isLoadingVerify } = useMutation({
    mutationFn: isChangePassword
      ? CommonAPI.verifyOTPChangePassword
      : CommonAPI.verifyOTP,
    onSuccess: ({ data }) => {
      if (data.hasOwnProperty("errorCodes")) {
        setOtpValue("");
      } else {
        if (isChangePassword) {
          successMsg(t(`message.update-password-success`));
          handleCloseSuccess();
        } else {
          setDataSession(LOCAL_STORAGE, "isLogin", true);
          navigate("/");
        }
        // setIsShow(false);
        dispatch(setIsConfirmUser(false));
      }
    },
  });

  const handleChange = (otp) => {
    setOtpValue(otp);
  };

  const user = getDataSession(LOCAL_STORAGE, "user");

  const handleClose = () => {
    if (!isChangePassword) {
      dispatch(setIsConfirmUser(false));
      removeCmsToken();
    }
    handleCloseModal();
  };

  const handleResend = async () => {
    await reset();
    await start();
    await getOTP(watch("userName"));
  };

  const handleConfirm = async () => {
    if (isChangePassword) {
      const payload = { ...watch(), otp: otpValue };
      await verifyOTP(payload);
    } else {
      await verifyOTP(otpValue);
    }
  };

  // useEffect(() => {
  //   start();
  //   if (!!data) {
  //     toast.success(t(`message.get-otp-success`));
  //   }
  // }, [data]);

  useEffect(() => {
    !isChangePassword && getOTP();
    start();
  }, []);

  return (
    <>
      <Dialog
        open={isShowModal}
        // onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <div className="flex items-center justify-between">
            <span> {t(`title.confirmation`)}</span>
            {handleClose ? (
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            ) : null}
          </div>
        </DialogTitle>
        <DialogContent>
          <>
            <p className="w-150 text-center">
              {t(`message.confirm-login-otp`, {
                phone: user?.phoneNumber || "",
              })}
            </p>
            <OtpInput
              containerStyle="justify-between gap-2"
              // className="w-28 border rounded-md"
              inputStyle="border rounded-md text-4xl"
              value={otpValue}
              onChange={handleChange}
              numInputs={6}
              isInputNum
            />
            <div className="mx-10 text-center">
              <LoadingButton
                className="py-6 px-12 h-21"
                disabled={counter > 0}
                onClick={handleResend}
              >
                {`${t(`btn.resend`)} ${counter}`}
              </LoadingButton>
            </div>
            <div className="text-center">
              <LoadingButton
                variant="contained"
                className="py-6 px-12 h-21"
                onClick={handleConfirm}
                loading={isLoadingVerify}
                disabled={otpValue.length !== 6}
              >
                {t(`btn.confirm`)}
              </LoadingButton>
            </div>
          </>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OTP;
